<!-- Clear Chat Confirmation Modal -->
<div class="modal fade" id="clearChatModal" tabindex="-1" aria-labelledby="clearChatModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title fw-bold" id="clearChatModalLabel">Clear Chat</h5>
                <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"
                    aria-label="Close"></button>
            </div>
            <div class="modal-body text-center py-4">
                <div class="mb-3">
                    <i class="bi bi-trash-fill text-danger" style="font-size: 3rem;"></i>
                </div>
                <p class="mb-0 text-muted px-2">Are you sure you want to clear your local chat history? This action
                    cannot be undone.</p>
            </div>
            <div class="modal-footer p-0 border-0 gap-0">
                <button type="button" class="btn btn-dark w-50 m-0 rounded-0 rounded-bottom-start fw-bold"
                    style="height: 4rem;" data-bs-dismiss="modal">Cancel</button>
                <button type="button" class="btn btn-danger w-50 m-0 rounded-0 rounded-bottom-end fw-bold"
                    style="height: 4rem;" data-bs-dismiss="modal" (click)="clearChat()" title="Confirm Clear Chat">
                    Clear Chat
                </button>
            </div>
        </div>
    </div>
</div>